export const DELETE_SUCCESS = 'Владелец ЭЗС удален';
export const DELETE_ERROR = 'Не удалось удалить владельца ЭЗС';
